/**
 * The types of connections that can be made.
 */
export enum ConnectionType {
  Database = 'Database',
  DataFusion = 'DataFusion',
  LLM = 'LLM',
  Box = 'Box',
  ObjectStorage = 'ObjectStorage',
  Service = 'Service'
}

/**
 * The data that is stored in the `config` field of a `Connection`.
 */
export type ConnectionData =
  | DatabaseConfig
  | DataFusionConfig
  | LLMConfig
  | BoxConfig
  | ServiceConfig;

/**
 * The possible responses to an invitation
 */
export enum InvitationResponse {
  Open = 'Open',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Canceled = 'Canceled'
}

/**
 * The status of a Job.
 */
export enum ExecStatus {
  Pending = 'pending',
  Scheduled = 'scheduled',
  Executing = 'executing',
  Canceled = 'canceled',
  Completed = 'completed',
  NeedsReview = 'needsreview',
  Rejected = 'rejected',
  Failed = 'failed',
  Retry = 'retry',
  Aborted = 'aborted'
}

/**
 * The source of a Job.
 */
export enum JobSource {
  Manual = 'manual',
  Scheduled = 'scheduled',
  Webhook = 'webhook',
  Triggered = 'triggered'
}

/**
 * The type of file change for an exec step file
 */
export enum ExecStepFileChangeType {
  Added = 'added',
  Modified = 'modified',
  Deleted = 'deleted'
}

/**
 * The possible types of secret sources.
 */
export enum SecretSourceType {
  Default = 'Default',
  Vault = 'Vault'
}

/**
 * Search methods
 */
export enum SearchMethod {
  Like = 'like',
  Fulltext = 'fulltext',
  Regex = 'regex'
}

/**
 * The version types that can be searched for
 */
export enum VersionType {
  Latest = 'latest',
  Head = 'head',
  All = 'all'
}

/**
 * The supported webhook types.
 */
export enum WebhookType {
  Box = 'Box',
  DropBox = 'DropBox'
}

/**
 * Generic value type for configurations
 */
export type Value = any;

// Import types to avoid circular dependencies
import type { DatabaseConfig, DataFusionConfig, LLMConfig, BoxConfig, ServiceConfig } from './connection.interface';












